import { useState } from 'react';

interface PagedResult<T> {
  data?: { pages: { items: T[] }[] };
  hasNextPage: boolean;
  isFetching: boolean;
  fetchNextPage: () => unknown;
}

/**
 * The search a server-paged picker sends with its query. Kept apart from the
 * query itself because the query's argument depends on it.
 */
export function usePickerSearch(): [string | undefined, (query: string) => void] {
  const [search, setSearch] = useState('');
  return [search || undefined, setSearch];
}

/**
 * Flattens an infinite query's pages into the rows loaded so far, plus the
 * props a `Select` needs to page and search through the rest on the server.
 */
export function pickerPages<T>(result: PagedResult<T>, onSearch: (query: string) => void) {
  return {
    items: result.data?.pages.flatMap((page) => page.items) ?? [],
    picker: {
      onSearch,
      hasMore: result.hasNextPage,
      loadingMore: result.isFetching,
      onLoadMore: () => void result.fetchNextPage(),
    },
  };
}
